import { render, staticRenderFns } from "./LiveUploadImage.vue?vue&type=template&id=fc8d019a&"
import script from "./LiveUploadImage.vue?vue&type=script&lang=js&"
export * from "./LiveUploadImage.vue?vue&type=script&lang=js&"
import style0 from "./LiveUploadImage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports